import React from 'react';
import { EntityAskAI } from '../common/EntityAskAI';

interface HistoryAskAIProps {
  fileIds: string[];
  teamId: string;
}

const getSuggestions = () => [
  'Summarize my recent recordings',
  'What are the main topics across these recordings?',
  'What action items were mentioned?',
  'Find key decisions made in these videos',
  'Create a summary report of recent activity',
];

export const HistoryAskAI: React.FC<HistoryAskAIProps> = ({
  fileIds,
  teamId,
}) => {
  return (
    <EntityAskAI
      entityName="Recent History"
      entityType="person"
      fileIds={fileIds}
      teamId={teamId}
      getSuggestions={getSuggestions}
    />
  );
};

export default HistoryAskAI;
